/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// react library for routing
import {Link} from "react-router-dom";
// reactstrap components
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Collapse,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Row,
    Container,
    Card,
    CardHeader,
    CardBody,
    ListGroup,
    ListGroupItem,
    Carousel,
    CarouselIndicators,
    CarouselItem,
    CarouselCaption, CarouselControl, Modal
} from 'reactstrap';
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.jsx";
import IndexHeader from "components/Headers/IndexHeader.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";
import ContentService from "../services/xgContentService";
import _ from "lodash";
import CompaniesCarousel from "./CompaniesCarousel";
import {countries} from "../util/countries";
import FormReactSelect from "../components/common/form/FormReactSelect";
import {services} from "../util/services";
import NotificationAlert from "react-notification-alert";
import {deliveryPeriods} from "../util/deliveryPeriods";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import FormInput from "../components/common/form/FormInput";
import ContactUsService from "../services/contactUsService";
import {Helmet} from "react-helmet";
import AppNavBar from "./AppNavBar";
import ShadowWrapper from "./ShadowWrapper";

class Blog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectKey: UtilService.uuidv4(),
            loginModal: false,
            contentData: {},
            collapseSearchServices: true,
            collapseSearchArticles: false,
            completeContentList:[],
            searchList:[],
            services : [],
            country :"",
            deliveryPeriod : "",
            contactUsModal:false,
            name :"",
            email: "",
            contactNumber:"",
            loading:false
        };
        this.notify = this.notify.bind(this);
        this.renderLogin = this.renderLogin.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleCountrySelectChange = this.handleCountrySelectChange.bind(this);
        this.submitServices = this.submitServices.bind(this);
        this.handleDeliveryPeriodChange = this.handleDeliveryPeriodChange.bind(this);
    }

    componentDidMount() {
        const {uniqueId} = this.props.match.params;
        ContentService.fetch(uniqueId).then((response) => {
            this.setState({contentData: response.data});
        });
    }

    handleCountrySelectChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedCountry: {}, country: ""});
        } else {
            this.setState({selectedCountry: valueObj, country: valueObj.key});
        }
    }

    handleDeliveryPeriodChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedDeliveryPeriod: {}, deliveryPeriod: ""});
        } else {
            this.setState({selectedDeliveryPeriod: valueObj, deliveryPeriod: valueObj.key});
        }
    }

    handleServicesChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({services: []});
        } else {
            this.setState({services: valueObj});
            const keys = _.map(valueObj, "key")
            this.setState({services: keys});
        }
    };

    submitServices(event) {
        if(this.state.services.length === 0|| this.state.country === "" || this.state.deliveryPeriod === ""){
            this.notify("error", "Error", "All fields are mandatory!")
        } else {
            // this.notify("success", "Query Submitted", "Thank you for sharing your query with us. We will shortly reply you back.")
            /*
              this.setState({services :[], country : "", deliveryPeriod : "",
                selectedCountry: {},selectedDeliveryPeriod: {}, selectKey : UtilService.uuidv4()})
            */
            this.toggleModal("contactUsModal");
        }
    }

    submitQuery = (event) => {
        this.setState({loading: true});
        if(this.state.services.length === 0|| this.state.country === "" || this.state.deliveryPeriod === ""
            || this.state.name === "" || this.state.email === "" || this.state.contactNumber === ""){
            this.notify("error", "Error", "All fields are mandatory!")
            this.setState({loading: false});
        } else {
            const data = {
                services: this.state.services,
                country: this.state.country,
                deliveryPeriod: this.state.deliveryPeriod,
                name: this.state.name,
                email: this.state.email,
                contactNumber: this.state.contactNumber,
            }
            ContactUsService.contactUs(data).then(response => {
                this.toggleModal("contactUsModal")
                this.notify("success", "Query Submitted", "Thank you for sharing your query with us. We will shortly reply you back.")
                this.setState({services :[], country : "", deliveryPeriod : "", name : "", email :"",
                    selectedCountry: {},selectedDeliveryPeriod: {}, selectKey : UtilService.uuidv4()});
                this.setState({loading: false});
            }).catch(response => {
                this.notify("danger", "Error", "Uh-oh seems like we are facing some technical glitch at our end!");
                this.setState({loading: false});
            })
        }
    }


    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };

    // Convert YouTube URL to embeddable format
     getYouTubeEmbedUrl = (url) => {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'www.youtube.com' && urlObj.searchParams.has('v')) {
            return `https://www.youtube.com/embed/${urlObj.searchParams.get('v')}`;
        }
        return url;
    };

    // Convert Spotify URL to embeddable format
     getSpotifyEmbedUrl = (url) => {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'open.spotify.com') {
            const [, type, id] = urlObj.pathname.split('/');
            return `https://open.spotify.com/embed/${type}/${id}`;
        }
        return url;
    };

     getEmbedUrl = (contentType,content) => {
        if (contentType === 'VIDEO') return this.getYouTubeEmbedUrl(content);
        if (contentType === 'AUDIO') return this.getSpotifyEmbedUrl(content);
        return null;
    };

    renderLogin() {
        return (
            <>
                <Button color="default" className="mb-3" outline
                        onClick={(event) => {
                            event.preventDefault();
                            this.props.history.push("/auth/login");
                        }}
                >
                    Login
                </Button>
            </>
        );
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    render() {
        const {title, content, contentType, category, uniqueId, dateCreatedLocal,seoText, userCompanyName} = this.state.contentData;
        return (
            <div style={{backgroundColor: "white"}}>
                <Helmet>
                    <title>{title}</title>
                    <meta name="description" content={`Read about ${title} in ${category}`}/>
                    <meta property="og:title" content={title}/>
                    <meta property="og:description" content={`Category: ${category}`}/>
                    <meta property="og:type" content="article"/>
                    <meta property="og:url" content={`https://yourwebsite.com/articles/${uniqueId}`}/>
                    <meta property="og:image" content="/path/to/default-thumbnail.jpg"/>
                </Helmet>
    {/*            <Helmet>*/}
    {/*                <script type="application/ld+json">*/}
    {/*                    {`*/}
    {/*  {*/}
    {/*    "@context": "http://schema.org",*/}
    {/*    "@type": "Article",*/}
    {/*    "mainEntityOfPage": {*/}
    {/*      "@type": "WebPage",*/}
    {/*      "@id": "https://yourwebsite.com/articles/${uniqueId}"*/}
    {/*    },*/}
    {/*    "headline": "${title}",*/}
    {/*    "datePublished": "${dateCreated}",*/}
    {/*    "author": {*/}
    {/*      "@type": "Person",*/}
    {/*      "name": "Author Name" // Replace with dynamic author if available*/}
    {/*    },*/}
    {/*    "publisher": {*/}
    {/*      "@type": "Organization",*/}
    {/*      "name": "Your Site Name",*/}
    {/*      "logo": {*/}
    {/*        "@type": "ImageObject",*/}
    {/*        "url": "https://yourwebsite.com/logo.png"*/}
    {/*      }*/}
    {/*    },*/}
    {/*    "image": "/path/to/default-thumbnail.jpg"*/}
    {/*  }*/}
    {/*`}*/}
    {/*                </script>*/}
    {/*            </Helmet>*/}

                {/* Navbar */}
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {/*Nav Bar*/}
                <AppNavBar loginModalToggle={this.toggleModal}/>

                {/* Hero Banner */}
                <div className="hero-banner">
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>{title}</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>
                <Container className="mt-10" style={{ backgroundColor: "white" }}>
                    <Row>
                        <Col>
                            <h1>{title}</h1>
                            <br />
                            <h3>
                                Published on &nbsp;
                                {new Date(dateCreatedLocal).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                }).replace(/\//g, "-")}
                            </h3>
                            <h5>Category : {category}</h5>
                            <br />
                            <div>
                                {contentType === "TEXT" && (
                                    <ShadowWrapper content={content}/>
                                )}
                                {(contentType === "VIDEO" || contentType === "AUDIO") && (
                                    <>
                                        <h3>{seoText}</h3>
                                        <br />
                                        <div style={{ position: "relative", paddingBottom: "56.25%", height: "0", overflow: "hidden" }}>
                                            <iframe
                                                style={{
                                                    position: "absolute",
                                                    top: "0",
                                                    left: "0",
                                                    width: "100%",
                                                    height: "100%",
                                                }}
                                                src={this.getEmbedUrl(contentType, content)}
                                                title={title}
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>



                <Container className="mt-10" style={{ backgroundColor: "white", height: "30vh" }}>
                    <Row className="d-flex justify-content-center align-items-center">
                        <Button
                            color="default"
                            className="mb-3"
                            outline
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.history.goBack();
                            }}
                        >
                            Go Back
                        </Button>
                    </Row>
                </Container>
                <Container className={"mt-10"}
                           style={{
                               border: "2px solid #4E5F7A",
                               padding: "1.5rem",
                               borderRadius: "2px",
                               // marginTop: "2.5rem", // Adjust to divide the buttons in half
                               position: "relative",
                               zIndex: "1",
                           }} >
                    <Col  className="text-center" style={{    marginTop: "-4rem"}}>
                        <Button color="default" className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: "1.5rem",
                                    padding: "1.5%"
                                }}>
                            Services
                        </Button>
                    </Col>
                    <Collapse isOpen={this.state.collapseSearchServices}>
                        <Form>
                            <Row form>
                                <Col md={12}>
                                    <FormGroup>
                                        <FormReactSelect
                                            selectKey={this.state.selectKey}
                                            isMulti={true}
                                            className="form-control-label"
                                            isSearchable={true}
                                            label="Select Services"
                                            name={"services"}
                                            onChange={this.handleServicesChange}
                                            optionValue={"value"}
                                            defaultValue={this.state.selectedServices}
                                            optionList={services}
                                            optionLabel={"key"}
                                            placeHolder="Select Services"
                                            errorMsg={this.state?.errorObj?.country || ""}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <FormReactSelect
                                            selectKey={this.state.selectKey}
                                            isMulti={false}
                                            className="form-control-label"
                                            isSearchable={true}
                                            label="Select Target Country/Market"
                                            name={"country"}
                                            onChange={this.handleCountrySelectChange}
                                            optionValue={"value"}
                                            defaultValue={this.state.selectedCountry}
                                            optionList={countries}
                                            optionLabel={"key"}
                                            placeHolder="Select Target Country/ Market"
                                            errorMsg={this.state?.errorObj?.country || ""}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <FormReactSelect
                                            selectKey={this.state.selectKey}
                                            isMulti={false}
                                            className="form-control-label"
                                            isSearchable={true}
                                            label="Delivery Period"
                                            name={"deliveryPeriod"}
                                            onChange={this.handleDeliveryPeriodChange}
                                            optionValue={"value"}
                                            defaultValue={this.state.selectedDeliveryPeriod}
                                            optionList={deliveryPeriods}
                                            optionLabel={"key"}
                                            placeHolder="Select Delivery Period"
                                            errorMsg={this.state?.errorObj?.deliveryPeriod || ""}
                                        />
                                    </FormGroup>
                                </Col>

                            </Row>

                            <div className="text-center">
                                <Button color="default" outline type="button" onClick={this.submitServices}>Submit</Button>
                            </div>
                        </Form>
                    </Collapse>


                </Container>
                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>

                <Modal
                    className="modal-dialog-centered"
                    isOpen={this.state.contactUsModal}
                    toggle={() => this.toggleModal("contactUsModal")}
                >
                    <div className="modal-header">
                        <h5 className="modal-title" id="contactUsModalLabel">
                            One final Step! Please provide us your contact details to reach back to you.
                        </h5>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleModal("contactUsModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col md="12">
                                <FormInput
                                    name="name"
                                    className="form-control-label"
                                    id="name"
                                    placeholder="Name"
                                    type="text"
                                    onChange={this.onChange}
                                    label="Name"
                                    value={this.state.name || ""}
                                    // errorMsg={this.props.errorObj.firstName || ""}
                                />
                            </Col>
                            <Col md="12">
                                <FormInput
                                    name="email"
                                    className="form-control-label"
                                    id="email"
                                    placeholder="Email address"
                                    type="text"
                                    onChange={this.onChange}
                                    label="Email Address"
                                    value={this.state.email || ""}
                                    // errorMsg={this.props.errorObj.middleName || ""}
                                />
                            </Col>
                            <Col md="12">
                                <FormInput
                                    name="contactNumber"
                                    className="form-control-label"
                                    id="email"
                                    placeholder="Contact Number"
                                    type="text"
                                    onChange={this.onChange}
                                    label="Contact Number"
                                    value={this.state.contactNumber || ""}
                                    // errorMsg={this.props.errorObj.middleName || ""}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <Button color="default" type="button" outline onClick={this.submitQuery}>
                            Submit Query
                        </Button>
                    </div>
                </Modal>


                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default Blog;
